import { useContext } from "react";
import { CalendarContextReact } from "../Calendar";
import { CalendarContext } from "../CalendarContext";

export function useCalendar(): CalendarContext {
  const context = useContext(CalendarContextReact);
  return context;
}
